import { Component, Input, OnInit } from '@angular/core';
import { UiService } from '../../../core/services/core.ui.service';
import { StateService } from '@uirouter/angular';
import { HttpClient } from '@angular/common/http';
import { GfTitleService } from '../../../core/services/core.title.service';
import * as _ from 'lodash';
import { doGetPromise } from '../../../core/config/core.httpclient-utils';

@Component({
  selector: 'scm-commit-diff',
  template: require('./scm.commit.component.html'),
})
export class ScmCommitDiffComponent implements OnInit {
  @Input() project: any;
  @Input() scm: any;

  commit: any = false;
  view: string;
  viewDiffEnabled: boolean = true;
  viewAssociationsEnabled: boolean = true;
  allowUpdates: boolean = false;

  constructor(
    private stateService: StateService,
    private titleService: GfTitleService,
    private uiService: UiService,
    private http: HttpClient,
  ) {}

  ngOnInit() {
    this.view = _.get(this.stateService.params, 'view', 'inline');
    this.viewDiffEnabled = true;
    this.viewAssociationsEnabled = true;

    const scmType = _.startCase(this.scm.scmType);
    const commithash = _.get(this.stateService.params, 'commithash', '');
    this.titleService.setTitle(this.project.name, scmType + ' Commit', commithash.substring(0, 7));

    this.allowUpdates = this.getScmPermission() >= 1;

    let url = `/api/scm/${this.stateService.params.unixName}/commit/${encodeURIComponent(commithash)}?rel=diff,trackeritem`;
    if (this.scm.scmType === 'cvs') {
      url += `&module=${this.stateService.params.module}`;
    }

    doGetPromise(this.http, url)
    .then(
        this.getCommitData,
        (error) => {
            console.log(error);
            this.uiService.message.showWarning(
              `Commit ${commithash} does not exist in this repository`,
              'Commit Not Found'
            );
            this.commit = { rel: { diff: [] } };
          }    
    );
  }

  getCommitData = (apiData) => {
    const data = apiData || { rel: {} };

    // Add summary data to each diff
    data.rel.diff = _.map(data.rel.diff, (diff) => {
      diff.added = _.reduce(
        diff.lines,
        (carry, line) => {
          if (line.type === 'new') {
            return carry + 1;
          }
          return carry;
        },
        0
      );
      diff.removed = _.reduce(
        diff.lines,
        (carry, line) => {
          if (line.type === 'old') {
            return carry + 1;
          }
          return carry;
        },
        0
      );
      return diff;
    });

    data.added = _.reduce(
      data.rel.diff,
      (sum, diff) => sum + diff.added,
      0
    );

    data.removed = _.reduce(
      data.rel.diff,
      (sum, diff) => sum + diff.removed,
      0
    );

    this.commit = data;
  }

  toggleCommitDiff() {
    this.viewDiffEnabled = !this.viewDiffEnabled;
  }

  toggleAssociations() {
    this.viewAssociationsEnabled = !this.viewAssociationsEnabled;
  }

  setView(view: string) {
    if (this.view !== view) {
      this.view = view;
      this.stateService.go('.', {
        ...this.stateService.params, view: view });
    }
  }

  private getScmPermission() {
    const plugins = _.get(this.project, 'rel.plugins', []);
    if (plugins.includes('scmgit')) {
      return _.get(this.project, 'rel.permissions.scmgit', 0);
    } else if (plugins.includes('scmsvn')) {
      return _.get(this.project, 'rel.permissions.scmsvn', 0);
    } else if (plugins.includes('scmcvs')) {
      return _.get(this.project, 'rel.permissions.scmcvs', 0);
    }
    return 0;
  }
}
